<template>
    <div class="registration-chips">
        <status-chip v-if="isComplete" label="Completed" type="success" icon="fa-circle-check"/>
        <status-chip v-else-if="window === 'in_progress' && isShortEvent" label="Happening now" type="success" icon="fa-circle-play"/>
        <status-chip v-else-if="window === 'in_progress'" :label="openThrough" type="neutral" icon="fa-calendar-check"/>
        <status-chip v-else-if="window === 'upcoming'" label="Upcoming" type="info" icon="fa-calendar"/>
        <status-chip v-if="state === 'po_pending'" label="Purchase order pending" type="warning" icon="fa-file-invoice"/>
        <status-chip v-if="outstanding && outstanding.log_unsigned" label="Attendance record to submit" type="warning" icon="fa-signature"/>
        <status-chip v-if="openApps" :label="openApps === 1 ? '1 application open' : openApps + ' applications open'" type="warning" icon="fa-file-pen"/>
    </div>
</template>

<script>
    import moment from "moment";
    import StatusChip from "../framework/StatusChip";
    import {formatDateOnly} from "../../utils/dates";

    // "Happening now" only makes sense for a real event; a conference whose
    // window runs longer than this is on-demand content that is merely open
    const LIVE_EVENT_MAX_DAYS = 14;

    /**
     * The status chips for a conference registration, shared by the
     * dashboard tile and the Conference Records card so the two can never
     * say different things. Inputs are the API's derived fields
     * (window / state / outstanding / is_complete) plus the conference dates.
     */
    export default {
        name: "RegistrationChips",
        components: {StatusChip},
        props: {
            window: {type: String, default: null},
            state: {type: String, default: null},
            outstanding: {type: Object, default: null},
            openApps: {type: Number, default: 0},
            isComplete: {type: Boolean, default: false},
            startAt: {type: [String, Date], default: null},
            endAt: {type: [String, Date], default: null},
        },
        computed: {
            isShortEvent() {
                if (!this.startAt) return true;
                const end = this.endAt || this.startAt;
                return moment(end).diff(moment(this.startAt), 'days') <= LIVE_EVENT_MAX_DAYS;
            },
            // Long-window (on-demand) content that is currently open
            openThrough() {
                const end = this.endAt || this.startAt;
                return end ? 'Open through ' + formatDateOnly(end, 'MMM D, YYYY') : 'Open now';
            }
        }
    };
</script>

<style lang="scss" scoped>
    .registration-chips {
        display: flex;
        flex-wrap: wrap;
        gap: 0.4rem;

        &:empty {
            display: none;
        }
    }
</style>
